import { Info } from 'lucide-react'

import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { useTranslation } from '@/hooks/useTranslation'

interface UnsupportedFileFeedbackFieldsProps {
	useCase: string
	onUseCaseChange: (value: string) => void
	useCaseError: boolean
	willingToShare: boolean
	onWillingToShareChange: (value: boolean) => void
	shareConsentError: boolean
	disabled?: boolean
}

export function UnsupportedFileFeedbackFields({
	useCase,
	onUseCaseChange,
	useCaseError,
	willingToShare,
	onWillingToShareChange,
	shareConsentError,
	disabled = false,
}: UnsupportedFileFeedbackFieldsProps) {
	const { t } = useTranslation()

	return (
		<>
			<div className="space-y-2">
				<Label htmlFor="unsupported-upload-use-case">
					{t('unsupportedFileUploadFeedback.useCaseLabel')}
				</Label>
				<Textarea
					id="unsupported-upload-use-case"
					value={useCase}
					onChange={(e) => onUseCaseChange(e.target.value)}
					placeholder={t('unsupportedFileUploadFeedback.useCasePlaceholder')}
					rows={4}
					maxLength={2000}
					disabled={disabled}
					aria-invalid={useCaseError}
				/>
				{useCaseError && (
					<p className="text-sm text-[#ff3131]" role="alert">
						{t('unsupportedFileUploadFeedback.useCaseValidationError')}
					</p>
				)}
			</div>

			<div className="space-y-2">
				<div className="flex items-start gap-3">
					<Checkbox
						id="unsupported-upload-willing-to-share"
						checked={willingToShare}
						onCheckedChange={(checked) => onWillingToShareChange(checked === true)}
						disabled={disabled}
						aria-invalid={shareConsentError}
					/>
					<div className="flex items-start gap-2">
						<Label
							htmlFor="unsupported-upload-willing-to-share"
							className="text-sm font-normal leading-snug"
						>
							{t('unsupportedFileUploadFeedback.metadataSectionLabel')}
						</Label>
						<Tooltip>
							<TooltipTrigger asChild>
								<button
									type="button"
									className="inline-flex shrink-0 text-muted-foreground hover:text-foreground cursor-help p-0 bg-transparent border-0 disabled:pointer-events-none disabled:opacity-50"
									aria-label={t('unsupportedFileUploadFeedback.metadataSectionLabel')}
									disabled={disabled}
								>
									<Info className="size-3.5" aria-hidden />
								</button>
							</TooltipTrigger>
							<TooltipContent side="right" className="max-w-[240px]">
								{t('unsupportedFileUploadFeedback.metadataTooltip')}
							</TooltipContent>
						</Tooltip>
					</div>
				</div>
				{shareConsentError && (
					<p className="text-sm text-[#ff3131]" role="alert">
						{t('unsupportedFileUploadFeedback.shareConsentError')}
					</p>
				)}
			</div>
		</>
	)
}
